import Swiper from 'swiper';
import { EffectFade, Navigation, Controller } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/controller';

let numerator = document.querySelector('.experience-gallery__numerator-current')

const gallery_info = new Swiper('.experience-gallery__gallery-info', {
  modules: [EffectFade],
  allowTouchMove: false,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  speed: 500
})

const gallery_images = new Swiper('.experience-gallery__slider', {
  modules: [Navigation, Controller],
  navigation: {
    prevEl: '.experience-gallery__gallery-prev',
    nextEl: '.experience-gallery__gallery-next'
  },
  on: {
    realIndexChange: function(swiper){
      numerator.innerHTML = (swiper.realIndex + 1)
    }
  },
  controller: {
    control: gallery_info
  },
  speed: 500
})